import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'redux/hooks/reduxHooks';
import { LOCAL_STORAGE } from 'shared/constants/local-storage-constants';
import { selectMeetingsArgs } from 'redux/selectors/selectors';
import { urls } from 'shared/constants/routing.constants';

export const useRestartDebate = () => {
  const navigate = useNavigate();
  const debateId = localStorage.getItem(LOCAL_STORAGE.currentDebateId);
  const meetingArgs = useAppSelector(selectMeetingsArgs);

  useEffect(() => {
    const isMeetingArgsEmpty =
      meetingArgs.topic.length === 0 &&
      meetingArgs.userIdentity.length === 0 &&
      meetingArgs.name.length === 0;

    if (debateId && isMeetingArgsEmpty) {
      // we need to wait for useGetProfileQuery fulfilled in CardMainButton component
      const REDIRECT_DELAY = 1000;
      const redirectTimer = setTimeout(() => {
        navigate(`${urls.commonPages.debateCard}/${debateId}`);
      }, REDIRECT_DELAY);

      return () => clearTimeout(redirectTimer);
    }
  }, [debateId, meetingArgs, navigate]);
};
